'use client';

import { RoceValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: RoceValues;
  onValuesChange: (field: keyof RoceValues, value: number) => void;
  translations: ToolsTranslations['roce'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof RoceValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '.');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.operatingProfit}</label>
        <input type="text" value={values.operatingProfit.toLocaleString('sv-SE')} onChange={handleChange('operatingProfit')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.totalAssets}</label>
        <input type="text" value={values.totalAssets.toLocaleString('sv-SE')} onChange={handleChange('totalAssets')} className={inputClass} placeholder="0" />
        <p className="text-xs text-gray-500 mt-1 italic">{translations.totalAssetsHint}</p>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.interestFreeLiabilities}</label>
        <input type="text" value={values.interestFreeLiabilities.toLocaleString('sv-SE')} onChange={handleChange('interestFreeLiabilities')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


